import { render, staticRenderFns } from "./CardQuestionDetailsPlaceholder.vue?vue&type=template&id=5774aba9"
import script from "./CardQuestionDetailsPlaceholder.vue?vue&type=script&lang=js"
export * from "./CardQuestionDetailsPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports